import React, { useMemo } from 'react'
import { makeStyles, TextField, Grid } from '@material-ui/core'
import SectionScreen from '../SectionScreen'
import SectionHeader from '../../shared/SectionHeader'
import PersonalSpace from '../../shared/PersonalSpace'
import { useClientDetails } from '../ClientDetailsFormContext'
import { fsExcludeClass } from '../../../../../utils/fsExclude'

const useStyles = makeStyles((theme) => ({
  integrationSection: {
    position: 'relative',
    padding: '10px',
    width: '30rem'
  },
  integrationField: {
    padding: '0px 22px'
  },
  inputLabel: {
    color: 'var(--text-color-main)',
    fontWeight: 600,
    '& span': {
      color: 'var(--text-color-main)'
    }
  }
}))
const IntegrationSection = () => {
  const { client } = useClientDetails()
  const classes = useStyles()
  const labelProps = {
    className: classes.inputLabel
  }
  const integrationEntries = useMemo(
    () => Object.entries(client.integrations || {}),
    [client.integrations]
  )

  if (!client.integrations) {
    return null
  }
  return (
    <SectionScreen sectionName='integration_identifiers' className={classes.integrationSection}>
      <SectionHeader text='Integration Identifiers' />
      <Grid container spacing={2} className={classes.integrationField}>
        {integrationEntries.map(([label, value]) => (
          <React.Fragment key={value}>
            <Grid item xs={12} md={6}>
              <TextField
                label='Integration'
                value={label || '--'}
                disabled
                fullWidth
                InputProps={{ disableUnderline: true }}
                className={fsExcludeClass}
                InputLabelProps={labelProps}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label='External ID'
                value={value || 'No External ID'}
                disabled
                fullWidth
                InputProps={{ disableUnderline: true }}
                className={fsExcludeClass}
                InputLabelProps={labelProps}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
      <PersonalSpace />
    </SectionScreen>
  )
}

export default IntegrationSection
